import type { TransferReceiptTranslations } from "../interfaces/transferReceipt";

export const transferReceiptTranslations: TransferReceiptTranslations = {
  title: "Transfer receipt",
  status_settled: "Payment successful",
  status_pending: "In progress",
  status_rejected: "Not completed",
  notice_pending: "The payment is still in progress: this receipt does not yet confirm the money arrived.",
  notice_rejected: "The payment was not completed and the money went back to the wallet.",
  amount_settled: "Amount sent",
  amount_pending: "Amount on its way",
  amount_rejected: "Amount not sent",
  via: "Via",
  number: "Receipt number",
  network_reference: "Bre-B transaction ID",
  to: "To",
  from: "From",
  name: "Name",
  entity: "Entity",
  reference: "Reference",
  hash: "Transaction hash",
  network: "Network",
  document: "Document",
  account: "Account",
  account_value: "{{currency}} wallet",
  sent_through: "Sent through",
  sender_entity: "ColocaPayments SAS",
  footer: "Receipt generated by Coloca Payments",
  file_prefix: "coloca-receipt",
  share_text: "I sent you {{amount}} with Coloca.",
  destination_breb_key: "Key",
  destination_pix_key: "PIX key",
  destination_bank_account: "Account",
  destination_clabe: "CLABE",
  destination_cbu_cvu: "CBU/CVU",
  destination_crypto_wallet: "Wallet",
  savings_account: "Savings account",
  checking_account: "Checking account",
  alias: "Alias",
  view: "View receipt",
  share_image: "Share image",
  share_pdf: "Share PDF",
  download_image: "Download image",
  download_pdf: "Download PDF",
  failed: "We could not create the receipt. Try again.",
};
